import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Router, RouterOutlet } from '@angular/router'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatButtonModule } from '@angular/material/button'
import { MessageComponent } from './components/message/message.component'
import { IsIgxAppHeaderComponent } from '@interserve/igx-angular'
import { environment } from '../environments/environment'
import { AccountInfo, BizFrontendApiService, } from '@interserve/angular'
import { IsbeauthComponent } from './components/isbeauth/isbeauth.component'
import { AuthService } from './components/isbeauth/auth.service'
import { appInitialize } from './localdata'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    CommonModule,
    RouterOutlet,
    MatToolbarModule,
    MatButtonModule,
    MatButtonModule,
    MessageComponent,
    IsIgxAppHeaderComponent,
    IsbeauthComponent,
  ],
})
export class AppComponent {
  title = ''
  titleLink = ''
  subTitle = ''
  subTitleLink = ''
  subTitleColor = ''
  environmentKey: 'prod' | 'dev' = environment.environmentCd === 'prod' ? 'prod' : 'dev'
  account: AccountInfo | undefined = undefined
  authEnable = true
  constructor(
    private router: Router, 
    private authService: AuthService,
    private bizFrontendApiService: BizFrontendApiService
  ) {}

  ngOnInit(): void {
    this.authService.accountSource$.subscribe((account) => {
      this.authEnable = account ? true : false
    })
    this.authService.loginStatusSource$.subscribe((loginStatus) => {
      this.authEnable = loginStatus
    })

    this.account = this.authService.Account
    this.authEnable = this.account ? true : false

    //★★暫定　メニューの取得部分省略してローカルデータ
    ;({
      title: this.title,
      titleLink: this.titleLink,
      subTitle: this.subTitle,
      subTitleLink: this.subTitleLink,
      subTitleColor: this.subTitleColor,
    } = appInitialize.items.layout.header)

    this.bizFrontendApiService.initializeApp('welcome').subscribe((res) => {
    })
  }
  // ngAfterViewInit() {
  //   this.account = this.authService.Account
  //   this.authEnable = this.account ? true : false
  // }
  clickSubTitle() {
    this.router.navigate(['welcome'])
  }
  logout(): void {
    this.authService.logout()
    location.reload()
  }
}
